import React, { useState } from 'react';
import { Flex, Checkbox, Text } from '@chakra-ui/react';
import { noop } from "../../utils";
export var CheckBoxLabel = function CheckBoxLabel(props) {
  var _a = props.isChecked,
      isChecked = _a === void 0 ? false : _a,
      _b = props.onChange,
      onChange = _b === void 0 ? noop : _b,
      id = props.id;

  var _c = useState(isChecked),
      checked = _c[0],
      setChekecked = _c[1];

  var toggleChecked = function toggleChecked() {
    setChekecked(!checked);
    onChange(!checked);
  };

  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "flex-start",
    lineHeight: "1.1"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    colorScheme: "brand",
    mr: "2",
    isChecked: checked,
    onChange: toggleChecked,
    id: id
  }), /*#__PURE__*/React.createElement(Text, {
    cursor: "pointer",
    userSelect: "none",
    onClick: toggleChecked
  }, props.children));
};